// Module
var code = " <div ng-class=\"{'transparent' : module.readOnly }\"> <div class=\"data-sync-button\"> <div class=\"synchronisationModule\"> <div> {{module.name | uppercase}} </div> </div> <oc-progress progress-pct=\"module.progress\" progress-class=\"module.generatedClass\">{{module.description}}<br>{{module.intStatus}}</oc-progress> </div> </div> ";
// Exports
module.exports = code;